import { ChevronUp } from "lucide-react";
import RUDNIcon from "../../../assets/rudn.svg?react";
import SearchInput from "./searchInput";

type Props = {
  isCollapsed: boolean;
  setIsCollapsed: React.Dispatch<React.SetStateAction<boolean>>;
};

export default function SidebarHeader({ isCollapsed, setIsCollapsed }: Props) {
  return (
    <div className="shrink-0">
      {/* Blue Header */}
      <div
        className="h-[62px] px-4 pr-[58px] flex items-center gap-3"
        style={{
          background: "linear-gradient(135deg, #1a5fb4 0%, #0d3a7a 100%)",
        }}
      >
        <div className="w-[34px] h-[34px] bg-white/15 rounded-lg flex items-center justify-center shrink-0">
          <RUDNIcon className="w-[18px] h-[18px] text-white" />
        </div>
        <div className="flex-1 flex flex-col justify-center min-w-0 overflow-hidden">
          <span className="text-[15px] font-bold text-white whitespace-nowrap">
            Навигация РУДН
          </span>
          <span className="text-[11px] text-white/70 whitespace-nowrap">
            Кампус Орджоникидзе 3
          </span>
        </div>
      </div>

      {/* Search Section */}
      <div className="px-4 py-[14px]">
        <SearchInput onExpandSidebar={() => setIsCollapsed(false)} />
      </div>

      {/* Toggle Button - Fixed position */}
      <button
        onClick={() => setIsCollapsed((c) => !c)}
        className="cursor-pointer fixed left-[330px] top-[14px] w-[34px] h-[34px] bg-white/10 rounded-lg flex items-center justify-center hover:bg-white/20 transition-colors z-[200]"
      >
        <ChevronUp
          className={`w-[18px] h-[18px] text-white transition-transform duration-300 ${
            isCollapsed ? "rotate-180" : ""
          }`}
        />
      </button>
    </div>
  );
}
